"use strict";

var _classCallCheck = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/inherits");

var _require = require("../helpers/internal-constants"),
    domSymbolTree = _require.domSymbolTree;

var _require2 = require("../helpers/namespaces"),
    SVG_NS = _require2.SVG_NS;

var _require3 = require("../../utils"),
    mixin = _require3.mixin;

var SVGAnimatedString = require("../generated/SVGAnimatedString");

var ElementImpl = require("./Element-impl").implementation;

var ElementCSSInlineStyleImpl = require("./ElementCSSInlineStyle-impl").implementation;

var GlobalEventHandlersImpl = require("./GlobalEventHandlers-impl").implementation;

var HTMLAndSVGElementSharedImpl = require("./HTMLAndSVGElementShared-impl").implementation;

var SVGElementImpl =
/*#__PURE__*/
function (_ElementImpl) {
  _inherits(SVGElementImpl, _ElementImpl);

  function SVGElementImpl(args, privateData) {
    var _this;

    _classCallCheck(this, SVGElementImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SVGElementImpl).call(this, args, privateData));

    _this._initHTMLAndSVGElement();

    _this._initElementCSSInlineStyle();

    _this._initGlobalEvents();

    return _this;
  }

  _createClass(SVGElementImpl, [{
    key: "className",
    get: function get() {
      return SVGAnimatedString.createImpl([], {
        element: this,
        attribute: "class"
      });
    }
  }, {
    key: "ownerSVGElement",
    get: function get() {
      var e = domSymbolTree.parent(this);

      while (e && e.namespaceURI === SVG_NS) {
        if (e.localName === "svg") {
          return e;
        }

        e = domSymbolTree.parent(e);
      }

      return null;
    }
  }, {
    key: "viewportElement",
    get: function get() {
      // TODO: <symbol>/<use> may make this different from ownerSVGElement.
      return this.ownerSVGElement;
    }
  }]);

  return SVGElementImpl;
}(ElementImpl);

SVGElementImpl.attributeRegistry = new Map();
mixin(SVGElementImpl.prototype, ElementCSSInlineStyleImpl.prototype);
mixin(SVGElementImpl.prototype, GlobalEventHandlersImpl.prototype);
mixin(SVGElementImpl.prototype, HTMLAndSVGElementSharedImpl.prototype);
exports.implementation = SVGElementImpl;